<template>
  <form>
    <h4 class="card-title">{{$t('medium_grant.technical__6_environmental_system')}}</h4>
    <p class="white-space-pre">{{$t('medium_grant.technical__6_environmental_system_sub')}}</p>
    <div class="row">
      <div class="col-lg-12">
        <div class="mt-4 mb-4">
          <a class="link-download" :href="downloadFiles[$i18n.locale]" target="_blank">{{$t('medium_grant.technical__6_environmental_download_esms')}}</a>
          <p class="mt-4">{{$t('medium_grant.technical__6_environmental_upload_esms')}}</p>
          <div class="mt-3">
            <upload-file v-if="GrantForm.initialized" v-model="GrantForm.files.technical.esmsQuestionaire" :file-data="GrantForm.files.technical.esmsQuestionaire" :is-editable="GrantForm.isEditable" :size-limit="GrantForm.fileSizeLimit" section="technical.esmsQuestionaire"></upload-file>
          </div>
        </div>
        <base-input>
            <textarea
              class="form-control"
              :placeholder="$t('medium_grant.general__write_here')"
              v-model="GrantForm.model.technical.environmentalEsms"
            >
            </textarea>
        </base-input>
      </div>
    </div>
  </form>
</template>
<script>
  import {GrantForm} from "@/services";

  export default {
    data() {
      return {
        GrantForm,
        downloadFiles: {
          en: '/files/en/BIOPAMA_AC_ESMS_Questionnaire_Medium-Grants_June_2019.docx',
          fr: '/files/fr/BIOPAMA_FA_SGES_Questionnaire_Subventions_Moyennes_June_2019.docx'
        }
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>
<style lang="scss" scoped>
  a {
    color: black;
    &:hover {
      text-decoration: underline;
    }
  }
</style>
